export const es = {
  // Navigation
  schedule: 'Horarios',
  employees: 'Empleados',
  vacations: 'Vacaciones y Ausencias',
  holidays: 'Feriados',
  store: 'Tienda',
  statistics: 'Estadísticas',
  export: 'Exportar',
  mySchedule: 'Mis Horarios',
  
  // Common actions
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  add: 'Agregar',
  close: 'Cerrar',
  back: 'Volver',
  next: 'Siguiente',
  previous: 'Anterior',
  search: 'Buscar',
  filter: 'Filtrar',
  clear: 'Limpiar',
  confirm: 'Confirmar',
  loading: 'Cargando...',
  
  // Authentication
  login: 'Iniciar Sesión',
  logout: 'Cerrar Sesión',
  username: 'Usuario',
  password: 'Contraseña',
  loginError: 'Usuario o contraseña inválidos',
  scheduleSystem: 'Sistema de Horarios',
  loginWithCredentials: 'Inicia sesión con tu usuario y contraseña',
  loggingIn: 'Iniciando sesión...',
  testInformation: 'Información de prueba',
  
  // Store
  storeSelector: 'Selector de Tiendas',
  selectStore: 'Selecciona una tienda',
  newStore: 'Nueva Tienda',
  storeName: 'Nombre de la Tienda',
  address: 'Dirección',
  phone: 'Teléfono',
  email: 'Email',
  createStore: 'Crear Tienda',
  editStore: 'Editar Tienda',
  deleteStore: 'Eliminar Tienda',
  storeCreated: 'Tienda creada exitosamente',
  storeUpdated: 'Tienda actualizada exitosamente',
  storeDeleted: 'Tienda eliminada exitosamente',
  storeSettings: 'Configuración de Tienda',
  weeklySchedule: 'Horario Semanal',
  scheduleExceptions: 'Excepciones de Horario',
  addException: 'Agregar Excepción',
  editScheduleException: 'Editar Excepción de Horario',
  addScheduleException: 'Agregar Excepción de Horario',
  updateException: 'Actualizar Excepción',
  reasonOptional: 'Motivo (opcional)',
  openingHours: 'Horario de Apertura',
  noExceptionsConfigured: 'No hay excepciones configuradas',
  date: 'Fecha',
  
  // Employees
  employeeName: 'Nombre Completo',
  weeklyLimit: 'Tope Semanal (horas)',
  color: 'Color del Empleado',
  role: 'Rol del Empleado',
  manager: 'Encargado',
  employee: 'Empleado',
  districtManager: 'Encargado de Distrito',
  employeeStartDate: 'Fecha de Inicio',
  birthday: 'Fecha de Nacimiento',
  vacationDays: 'Días de Vacaciones por Año',
  unavailableTimes: 'Horarios No Disponibles',
  addEmployee: 'Agregar Empleado',
  editEmployee: 'Editar Empleado',
  deleteEmployee: 'Eliminar Empleado',
  employeeCreated: 'Empleado creado exitosamente',
  employeeUpdated: 'Empleado actualizado exitosamente',
  employeeDeleted: 'Empleado eliminado exitosamente',
  newEmployee: 'Nuevo Empleado',
  regularEmployee: 'Empleado Regular',
  mainManager: 'Encargado Principal',
  uniqueUsernameForLogin: 'Usuario único para el login del empleado',
  passwordForLogin: 'Contraseña para el login del empleado',
  employeeList: 'Lista de Empleados',
  active: 'Activo',
  inactive: 'Inactivo',
  create: 'Crear',
  update: 'Actualizar',
  manageEmployeeInfo: 'Administra la información de tus empleados',
  
  // Schedule
  week: 'Semana',
  month: 'Mes',
  day: 'Día',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  startTime: 'Hora de Inicio',
  endTime: 'Hora de Fin',
  hours: 'Horas',
  duration: 'Duración',
  published: 'Publicar',
  draft: 'Borrador',
  addShift: 'Crear Turnos',
  editShift: 'Editar Turno',
  deleteShift: 'Eliminar Turno',
  copyWeek: 'Copiar Semana',
  repeatWeek: 'Repetir',
  deleteWeek: 'Borrar Semana',
  compactMode: 'Modo Compacto',
  normalMode: 'Modo Normal',
  thisWeek: 'Esta Semana',
  copying: 'Copiando...',
  clickEmployeeToCreateShift: 'Haz clic en un empleado para crear un turno manualmente',
  view24h: 'Ver 24h',
  
  // Absences
  absenceManagement: 'Gestión de Ausencias',
  absenceType: 'Tipo de Ausencia',
  vacation: 'Vacaciones',
  sick: 'Enfermedad',
  personal: 'Personal',
  other: 'Otro',
  absenceStartDate: 'Fecha de Inicio',
  absenceEndDate: 'Fecha de Fin',
  reason: 'Motivo',
  status: 'Estado',
  pending: 'Pendiente',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  newRequest: 'Nueva Solicitud',
  requestSubmitted: 'Solicitud enviada exitosamente',
  remainingVacationDays: 'Días de Vacaciones Restantes',
  type: 'Tipo',
  dates: 'Fechas',
  days: 'Días',
  actions: 'Acciones',
  absenceTypeLabel: 'Tipo de Ausencia',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  employeeInfo: 'Información del Empleado',
  requestDate: 'Fecha de Solicitud',
  approvedBy: 'Aprobado por:',
  rejectedBy: 'Rechazado por:',
  rejectionReason: 'Motivo del rechazo:',
  manageAllAbsenceRequests: 'Administra todas las solicitudes de ausencias',
  totalAbsences: 'Total Ausencias',
  allTypes: 'Todos los tipos',
  allStatuses: 'Todos los estados',
  allEmployees: 'Todos los empleados',
  requestDetails: 'Detalles de la Solicitud',
  name: 'Nombre',
  absenceInformation: 'Información de la Ausencia',
  scheduleRestrictions: 'Restricciones de horario',
  shiftPendingPublication: 'turno pendiente de publicación',
  shiftsPendingPublication: 'turnos pendientes de publicación',
  defineOpeningHoursAndExceptions: 'Define el horario de apertura y excepciones',
  open: 'Abierto',
  closed: 'Cerrado',
  opens: 'Abre',
  closes: 'Cierra',
  range: 'Rango',
  addRange: 'Agregar rango',
  addAnotherRange: 'Agregar otro rango',
  lastSynchronization: 'Última sincronización',
  holidayInformation: 'Información sobre Feriados',
  nationalHolidaysSyncAutomatically: 'Los feriados nacionales se sincronizan automáticamente cada año. Estos días usarán el horario asignado a feriados en la pestaña de tienda, a menos que crees una excepción específica.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Métricas de cobertura y carga de trabajo',
  activeEmployees: 'Empleados Activos',
  shiftsThisWeek: 'Turnos Esta Semana',
  totalHours: 'Horas Totales',
  statisticsByEmployee: 'Estadísticas por Empleado',
  assignedHours: 'Horas Asignadas',
  weeklyCap: 'Tope Semanal',
  utilization: '% Utilización',
  busiestDay: 'Día Más Ocupado',
  daysWithoutWeekend: 'Días Sin Fin de Semana',
  
  // Export
  exportSchedules: 'Exportar Horarios',
  exportPublishedSchedulesInDifferentFormats: 'Exporta los horarios publicados en diferentes formatos',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'No hay horarios publicados para exportar',
  
  // Additional UI elements
  newAbsenceRequest: 'Nueva Solicitud de Ausencia',
  selectEmployee: 'Seleccionar empleado',
  describeAbsenceReason: 'Describe el motivo de la ausencia...',
  submitting: 'Enviando...',
  submitRequest: 'Enviar Solicitud',
  vacationsAndAbsences: 'Vacaciones y Ausencias',
  requestVacation: 'Solicitar Vacaciones',
  newVacationRequest: 'Nueva Solicitud de Vacaciones',
  myVacationRequests: 'Mis Solicitudes de Vacaciones',
  clickRequestVacationToCreateFirstRequest: 'Haz clic en "Solicitar Vacaciones" para crear tu primera solicitud',
  vacationManagement: 'Gestión de Vacaciones',
  vacationRequests: 'Solicitudes de Vacaciones',
  
  // Absence Types
  sickness: 'Enfermedad',
  unjustified: 'Ausencia No Justificada',
  special: 'Licencia Especial',
  
  // Holidays
  holidayName: 'Nombre del Feriado',
  holidayDate: 'Fecha del Feriado',
  addHoliday: 'Agregar',
  editHoliday: 'Editar Feriado',
  automaticHolidayManagement: 'Gestión automática de días festivos nacionales',
  addCustomHoliday: 'Agregar Feriado Personalizado',
  editCustomHoliday: 'Editar Feriado Personalizado',
  updateHoliday: 'Actualizar Feriado',
  nationalHolidays: 'Feriados Nacionales',
  loadingHolidays: 'Cargando feriados...',
  deleteHoliday: 'Eliminar Feriado',
  
  // Statistics
  totalEmployees: 'Total de Empleados',
  totalShifts: 'Total de Turnos',
  averageHours: 'Promedio de Horas',
  coverageProblems: 'Problemas de Cobertura',
  noProblems: 'No se detectaron problemas de cobertura',
  gap: 'Hueco',
  conflict: 'Conflicto',
  overtime: 'Jornada excesiva',
  emptyDay: 'Sin turnos',
  weeklyOvertime: 'Horas semanales excesivas',
  storeClosed: 'Tienda cerrada',
  
  // Export
  exportData: 'Exportar Datos',
  selectDateRange: 'Seleccionar Rango de Fechas',
  from: 'Desde',
  to: 'Hasta',
  exportFormat: 'Formato de Exportación',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Datos exportados exitosamente',
  
  // Configuration
  configuration: 'Configuración',
  language: 'Idioma de la aplicación',
  country: 'País (para feriados)',

  // Header
  scheduleAdministrationPanel: 'Panel de Administración de Horarios',
  welcome: 'Bienvenido',
  invalidDay: 'Día inválido',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Atajos de Teclado',
  showHideShortcutsHelp: 'Mostrar/ocultar ayuda de atajos',
  toggleDarkMode: 'Alternar modo oscuro',
  closeModalsAndPanels: 'Cerrar modales y paneles',
  openNotificationCenter: 'Abrir centro de notificaciones',
  goToScheduleTab: 'Ir a pestaña Horarios',
  goToEmployeesTab: 'Ir a pestaña Empleados',
  goToConfigurationTab: 'Ir a pestaña Configuración',
  goToStatisticsTab: 'Ir a pestaña Estadísticas',
  goToExportTab: 'Ir a pestaña Exportar',
  createNewShift: 'Crear nuevo turno',
  saveSchedules: 'Guardar horarios',
  publishSchedules: 'Publicar horarios',
  navigateBetweenWeeks: 'Navegar entre semanas',
  zoomInOut: 'Zoom in/out',
  resetZoom: 'Resetear zoom',
  addNewEmployee: 'Agregar nuevo empleado',
  searchEmployees: 'Buscar empleados',
  saveEmployee: 'Guardar empleado',
  cancelEdit: 'Cancelar edición',
  refreshStatistics: 'Refrescar estadísticas',
  exportStatistics: 'Exportar estadísticas',
  refreshSchedules: 'Refrescar horarios',
  pressCtrlSlashToShowHideHelp: 'Presiona Ctrl + / para mostrar/ocultar esta ayuda',

  // Keyboard Shortcut Categories
  general: 'General',
  navigation: 'Navegación',
  schedules: 'Horarios',

  // Coverage Problems
  gapWithoutCoverage: 'Hueco sin cobertura de',
  excessiveWorkday: 'Jornada excesiva',
  noShifts: 'Sin turnos',
  excessiveWeeklyHours: 'Horas semanales excesivas',
  problem: 'Problema',
  
  // Notifications
  notifications: 'Notificaciones',
  noNotifications: 'No hay notificaciones',
  markAllAsRead: 'Marcar todas como leídas',
  markAsRead: 'Marcar como leída',
  justNow: 'Ahora',
  hoursAgo: 'h',
  yesterday: 'Ayer',
  birthdayToday: 'Cumpleaños hoy',
  reviewAssignments: 'Revisar asignaciones',
  verifyAllEmployeesHaveAssignedSchedules: 'Verifica que todos los empleados tengan horarios asignados',
  notification: 'notificación',
  
  // Errors
  error: 'Error',
  success: 'Éxito',
  warning: 'Advertencia',
  info: 'Información',
  required: 'Este campo es obligatorio',
  invalidDate: 'Fecha inválida',
  invalidTime: 'Hora inválida',
  networkError: 'Error de red. Por favor intenta de nuevo.',
  
  // Confirmations
  confirmDelete: '¿Estás seguro de que quieres eliminar este elemento?',
  confirmDeleteWeek: '¿Estás seguro de que quieres borrar todos los turnos de esta semana? Esta acción no se puede deshacer.',
  confirmDeleteAll: '¿Estás seguro de que quieres borrar TODOS los datos? Esta acción eliminará todas las tiendas, empleados y turnos. Esta acción no se puede deshacer.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'DD/MM/YYYY',
  
  // Days of week
  daysOfWeek: {
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mié',
    thursday: 'Jue',
    friday: 'Vie',
    saturday: 'Sáb',
    sunday: 'Dom'
  },

  // Store Management
  storeManagement: 'Gestión de Tiendas',
  welcomeSelectStore: 'Bienvenido/a, {name}. Selecciona una tienda para gestionar o crea una nueva.',
  activeStores: 'Tiendas Activas',
  storeList: 'Lista de Tiendas',
  generateTestData: 'Generar Datos de Prueba',
  noStoresYet: 'Aún no hay tiendas creadas',
  createFirstStore: 'Crea tu primera tienda para comenzar a gestionar horarios y empleados.',
  storeAddress: 'Dirección',
  storePhone: 'Teléfono',
  storeEmail: 'Email',
  storeNamePlaceholder: 'Ej: Tienda Centro',
  storeAddressPlaceholder: 'Ej: Calle Principal 123',
  storePhonePlaceholder: 'Ej: +34 123 456 789',
  storeEmailPlaceholder: 'Ej: tienda@empresa.com',
  editStoreTitle: 'Editar Tienda',
  createStoreTitle: 'Crear Nueva Tienda',
  storeNameRequired: 'El nombre de la tienda es obligatorio',
  confirmDeleteStore: '¿Estás seguro de que quieres eliminar la tienda "{storeName}"? Esta acción no se puede deshacer.',
  shifts: 'Turnos',
  manageStore: 'Gestionar Tienda',

  // Date Format
  dateFormat: 'Formato de Fecha',
  dateFormatDDMMYYYY: 'DD/MM/YYYY',
  dateFormatMMDDYYYY: 'MM/DD/YYYY',
  dateFormatYYYYMMDD: 'YYYY/MM/DD',

  // Employee Dashboard
  mySchedules: 'Mis Horarios',
  welcomeEmployee: 'Bienvenido/a, {name}',
  previousWeek: 'Semana Anterior',
  nextWeek: 'Semana Siguiente',
  thisMonth: 'Este Mes',
  myShifts: 'Mis Turnos',
  shiftCalendar: 'Calendario de Turnos',
  list: 'Lista',
  calendar: 'Calendario',
  noShiftsThisWeek: 'No tienes turnos asignados esta semana',
  noShiftsThisMonth: 'No tienes turnos asignados este mes',
  previousMonth: 'Mes Anterior',
  nextMonth: 'Mes Siguiente',
  closeSession: 'Cerrar Sesión',

  // Time Clock
  timeClock: 'Fichar',
  clockIn: 'Fichar Entrada',
  clockOut: 'Fichar Salida',
  lastAction: 'Última acción',
  entry: 'Entrada',
  exit: 'Salida',
  gettingLocation: 'Obteniendo ubicación...',
  locationPermissionDenied: 'Permiso de ubicación denegado. Por favor, permite el acceso a la ubicación en la configuración del navegador.',
  locationUnavailable: 'No se pudo obtener la ubicación. Verifica que el GPS esté activado.',
  locationTimeout: 'Tiempo de espera agotado al obtener la ubicación.',
  tooFarFromStore: 'Estás demasiado lejos de la tienda ({distance}m). Distancia máxima permitida: {maxDistance}m',
  noShiftsOrEntries: 'Sin turnos ni fichadas'
};
